var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',[_c('v-treeview',{attrs:{"selectable":"","name":"permission_upd","items":_vm.permission,"selection-type":"independent","selected-color":"#50ABA3","open-on-click":"","open-all":""},on:{"input":_vm.selected},model:{value:(_vm.selectedItem),callback:function ($$v) {_vm.selectedItem=$$v},expression:"selectedItem"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }